module.exports = __webpack_public_path__ + "static/media/growth.d0a1e21e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/growth.svg
// module id = 316
// module chunks = 31